// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file realtime/app_event_payload.proto (package protos.realtime, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { MyAccount } from "../entities/app/my_account/my_account_pb";
import { file_entities_app_my_account_my_account } from "../entities/app/my_account/my_account_pb";
import type { Chat } from "../entities/app/chats/chat_pb";
import { file_entities_app_chats_chat } from "../entities/app/chats/chat_pb";
import type { Message as Message$1 } from "../entities/app/messages/message_pb";
import { file_entities_app_messages_message } from "../entities/app/messages/message_pb";
import type { VisionLocation } from "../vision/projects/v1/vision_location_pb";
import { file_vision_projects_v1_vision_location } from "../vision/projects/v1/vision_location_pb";
import type { VisionPresenceKind } from "../vision/projects/v1/vision_presence_pb";
import { file_vision_projects_v1_vision_presence } from "../vision/projects/v1/vision_presence_pb";
import type { ProjectImage } from "../vision/assets/v1/vision_asset_pb";
import { file_vision_assets_v1_vision_asset } from "../vision/assets/v1/vision_asset_pb";
import type { VisionInviteView, VisionMemberView } from "../vision/membership/v1/vision_membership_pb";
import { file_vision_membership_v1_vision_membership } from "../vision/membership/v1/vision_membership_pb";
import type { VisionGeneration, VisionGenerationLike } from "../vision/generations/v1/vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "../vision/generations/v1/vision_generation_pb";
import type { GenerationCrop } from "../vision/generations/v1/generation_crop_pb";
import { file_vision_generations_v1_generation_crop } from "../vision/generations/v1/generation_crop_pb";
import type { MaskRegion } from "../vision/generations/v1/mask_region_pb";
import { file_vision_generations_v1_mask_region } from "../vision/generations/v1/mask_region_pb";
import type { VisionChatMessage } from "../vision/chat/v1/vision_chat_message_pb";
import { file_vision_chat_v1_vision_chat_message } from "../vision/chat/v1/vision_chat_message_pb";
import type { VisionShot } from "../vision/shotlist/v1/vision_shot_pb";
import { file_vision_shotlist_v1_vision_shot } from "../vision/shotlist/v1/vision_shot_pb";
import type { VisionCastMember } from "../vision/shotlist/v1/vision_cast_member_pb";
import { file_vision_shotlist_v1_vision_cast_member } from "../vision/shotlist/v1/vision_cast_member_pb";
import type { VisionProp } from "../vision/shotlist/v1/vision_prop_pb";
import { file_vision_shotlist_v1_vision_prop } from "../vision/shotlist/v1/vision_prop_pb";
import type { VisionShotlistPreset, VisionShotlistPresetCategory } from "../vision/shotlist/v1/vision_shotlist_preset_pb";
import { file_vision_shotlist_v1_vision_shotlist_preset } from "../vision/shotlist/v1/vision_shotlist_preset_pb";
import type { VisionShotlistConfig } from "../vision/shotlist/v1/vision_shotlist_config_pb";
import { file_vision_shotlist_v1_vision_shotlist_config } from "../vision/shotlist/v1/vision_shotlist_config_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file realtime/app_event_payload.proto.
 */
export const file_realtime_app_event_payload: GenFile = /*@__PURE__*/
  fileDesc("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", [file_entities_app_my_account_my_account, file_entities_app_chats_chat, file_entities_app_messages_message, file_vision_projects_v1_vision_location, file_vision_projects_v1_vision_presence, file_vision_assets_v1_vision_asset, file_vision_membership_v1_vision_membership, file_vision_generations_v1_vision_generation, file_vision_generations_v1_generation_crop, file_vision_generations_v1_mask_region, file_vision_chat_v1_vision_chat_message, file_vision_shotlist_v1_vision_shot, file_vision_shotlist_v1_vision_cast_member, file_vision_shotlist_v1_vision_prop, file_vision_shotlist_v1_vision_shotlist_preset, file_vision_shotlist_v1_vision_shotlist_config, file_google_protobuf_timestamp]);

/**
 * @generated from message protos.realtime.AppEventPayload
 */
export type AppEventPayload = Message<"protos.realtime.AppEventPayload"> & {
  /**
   * @generated from oneof protos.realtime.AppEventPayload.payload
   */
  payload: {
    /**
     * @generated from field: protos.realtime.AppEventPayload.Status status = 1;
     */
    value: AppEventPayload_Status;
    case: "status";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.MyAccountUpdated my_account_updated = 2;
     */
    value: AppEventPayload_MyAccountUpdated;
    case: "myAccountUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.ChatCreated chat_created = 3;
     */
    value: AppEventPayload_ChatCreated;
    case: "chatCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.ChatUpdated chat_updated = 4;
     */
    value: AppEventPayload_ChatUpdated;
    case: "chatUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.ChatDeleted chat_deleted = 5;
     */
    value: AppEventPayload_ChatDeleted;
    case: "chatDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.ChatTyping chat_typing = 6;
     */
    value: AppEventPayload_ChatTyping;
    case: "chatTyping";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.MessageCreated message_created = 7;
     */
    value: AppEventPayload_MessageCreated;
    case: "messageCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.MessageUpdated message_updated = 8;
     */
    value: AppEventPayload_MessageUpdated;
    case: "messageUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.MessageDeleted message_deleted = 9;
     */
    value: AppEventPayload_MessageDeleted;
    case: "messageDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectLocationCreated vision_project_location_created = 10;
     */
    value: AppEventPayload_VisionProjectLocationCreated;
    case: "visionProjectLocationCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectLocationUpdated vision_project_location_updated = 11;
     */
    value: AppEventPayload_VisionProjectLocationUpdated;
    case: "visionProjectLocationUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectLocationDeleted vision_project_location_deleted = 12;
     */
    value: AppEventPayload_VisionProjectLocationDeleted;
    case: "visionProjectLocationDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectImageCreated vision_project_image_created = 13;
     */
    value: AppEventPayload_VisionProjectImageCreated;
    case: "visionProjectImageCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionInviteCreated vision_invite_created = 14;
     */
    value: AppEventPayload_VisionInviteCreated;
    case: "visionInviteCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionInviteDeleted vision_invite_deleted = 15;
     */
    value: AppEventPayload_VisionInviteDeleted;
    case: "visionInviteDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionMemberJoined vision_member_joined = 16;
     */
    value: AppEventPayload_VisionMemberJoined;
    case: "visionMemberJoined";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionMemberRemoved vision_member_removed = 17;
     */
    value: AppEventPayload_VisionMemberRemoved;
    case: "visionMemberRemoved";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionMemberRoleChanged vision_member_role_changed = 18;
     */
    value: AppEventPayload_VisionMemberRoleChanged;
    case: "visionMemberRoleChanged";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectOwnershipTransferred vision_project_ownership_transferred = 19;
     */
    value: AppEventPayload_VisionProjectOwnershipTransferred;
    case: "visionProjectOwnershipTransferred";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectImageCategorized vision_project_image_categorized = 20;
     */
    value: AppEventPayload_VisionProjectImageCategorized;
    case: "visionProjectImageCategorized";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectImagesCategorized vision_project_images_categorized = 21;
     */
    value: AppEventPayload_VisionProjectImagesCategorized;
    case: "visionProjectImagesCategorized";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionGenerationCompleted vision_generation_completed = 22;
     */
    value: AppEventPayload_VisionGenerationCompleted;
    case: "visionGenerationCompleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionGenerationFailed vision_generation_failed = 23;
     */
    value: AppEventPayload_VisionGenerationFailed;
    case: "visionGenerationFailed";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectCreditsUpdated vision_project_credits_updated = 24;
     */
    value: AppEventPayload_VisionProjectCreditsUpdated;
    case: "visionProjectCreditsUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionGenerationUpdated vision_generation_updated = 25;
     */
    value: AppEventPayload_VisionGenerationUpdated;
    case: "visionGenerationUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionChatMessageCreated vision_chat_message_created = 26;
     */
    value: AppEventPayload_VisionChatMessageCreated;
    case: "visionChatMessageCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionChatMessageDeleted vision_chat_message_deleted = 27;
     */
    value: AppEventPayload_VisionChatMessageDeleted;
    case: "visionChatMessageDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionGenerationLikesUpdated vision_generation_likes_updated = 28;
     */
    value: AppEventPayload_VisionGenerationLikesUpdated;
    case: "visionGenerationLikesUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionDisplaySelectionChanged vision_display_selection_changed = 29;
     */
    value: AppEventPayload_VisionDisplaySelectionChanged;
    case: "visionDisplaySelectionChanged";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionImagesReordered vision_images_reordered = 30;
     */
    value: AppEventPayload_VisionImagesReordered;
    case: "visionImagesReordered";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionGenerationDeleted vision_generation_deleted = 31;
     */
    value: AppEventPayload_VisionGenerationDeleted;
    case: "visionGenerationDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionImageRotated vision_image_rotated = 32;
     */
    value: AppEventPayload_VisionImageRotated;
    case: "visionImageRotated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionGenerationCropUpdated vision_generation_crop_updated = 33;
     */
    value: AppEventPayload_VisionGenerationCropUpdated;
    case: "visionGenerationCropUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionImageMaskRegionsUpdated vision_image_mask_regions_updated = 34;
     */
    value: AppEventPayload_VisionImageMaskRegionsUpdated;
    case: "visionImageMaskRegionsUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionGenerationMaskRegionsUpdated vision_generation_mask_regions_updated = 35;
     */
    value: AppEventPayload_VisionGenerationMaskRegionsUpdated;
    case: "visionGenerationMaskRegionsUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionGenerationStarted vision_generation_started = 36;
     */
    value: AppEventPayload_VisionGenerationStarted;
    case: "visionGenerationStarted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistShotsCreated vision_shotlist_shots_created = 38;
     */
    value: AppEventPayload_VisionShotlistShotsCreated;
    case: "visionShotlistShotsCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistShotUpdated vision_shotlist_shot_updated = 39;
     */
    value: AppEventPayload_VisionShotlistShotUpdated;
    case: "visionShotlistShotUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistShotDeleted vision_shotlist_shot_deleted = 40;
     */
    value: AppEventPayload_VisionShotlistShotDeleted;
    case: "visionShotlistShotDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistShotHidden vision_shotlist_shot_hidden = 41;
     */
    value: AppEventPayload_VisionShotlistShotHidden;
    case: "visionShotlistShotHidden";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistCastCreated vision_shotlist_cast_created = 42;
     */
    value: AppEventPayload_VisionShotlistCastCreated;
    case: "visionShotlistCastCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistCastUpdated vision_shotlist_cast_updated = 43;
     */
    value: AppEventPayload_VisionShotlistCastUpdated;
    case: "visionShotlistCastUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistCastDeleted vision_shotlist_cast_deleted = 44;
     */
    value: AppEventPayload_VisionShotlistCastDeleted;
    case: "visionShotlistCastDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistPropCreated vision_shotlist_prop_created = 45;
     */
    value: AppEventPayload_VisionShotlistPropCreated;
    case: "visionShotlistPropCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistPropDeleted vision_shotlist_prop_deleted = 46;
     */
    value: AppEventPayload_VisionShotlistPropDeleted;
    case: "visionShotlistPropDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistPresetCreated vision_shotlist_preset_created = 47;
     */
    value: AppEventPayload_VisionShotlistPresetCreated;
    case: "visionShotlistPresetCreated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionShotlistConfigUpdated vision_shotlist_config_updated = 48;
     */
    value: AppEventPayload_VisionShotlistConfigUpdated;
    case: "visionShotlistConfigUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionImageDescriptionUpdated vision_image_description_updated = 49;
     */
    value: AppEventPayload_VisionImageDescriptionUpdated;
    case: "visionImageDescriptionUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionImageFrameUpdated vision_image_frame_updated = 50;
     */
    value: AppEventPayload_VisionImageFrameUpdated;
    case: "visionImageFrameUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectImageMoved vision_project_image_moved = 51;
     */
    value: AppEventPayload_VisionProjectImageMoved;
    case: "visionProjectImageMoved";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectImagesBulkMoved vision_project_images_bulk_moved = 52;
     */
    value: AppEventPayload_VisionProjectImagesBulkMoved;
    case: "visionProjectImagesBulkMoved";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectImageDeleted vision_project_image_deleted = 53;
     */
    value: AppEventPayload_VisionProjectImageDeleted;
    case: "visionProjectImageDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectSettingsUpdated vision_project_settings_updated = 54;
     */
    value: AppEventPayload_VisionProjectSettingsUpdated;
    case: "visionProjectSettingsUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectDeleted vision_project_deleted = 55;
     */
    value: AppEventPayload_VisionProjectDeleted;
    case: "visionProjectDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionPresenceUpdated vision_presence_updated = 56;
     */
    value: AppEventPayload_VisionPresenceUpdated;
    case: "visionPresenceUpdated";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.VisionProjectUncategorizedImagesDeleted vision_project_uncategorized_images_deleted = 57;
     */
    value: AppEventPayload_VisionProjectUncategorizedImagesDeleted;
    case: "visionProjectUncategorizedImagesDeleted";
  } | {
    /**
     * @generated from field: protos.realtime.AppEventPayload.AccountDeleted account_deleted = 58;
     */
    value: AppEventPayload_AccountDeleted;
    case: "accountDeleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.realtime.AppEventPayload.
 * Use `create(AppEventPayloadSchema)` to create a new message.
 */
export const AppEventPayloadSchema: GenMessage<AppEventPayload> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0);

/**
 * @generated from message protos.realtime.AppEventPayload.Status
 */
export type AppEventPayload_Status = Message<"protos.realtime.AppEventPayload.Status"> & {
};

/**
 * Describes the message protos.realtime.AppEventPayload.Status.
 * Use `create(AppEventPayload_StatusSchema)` to create a new message.
 */
export const AppEventPayload_StatusSchema: GenMessage<AppEventPayload_Status> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 0);

/**
 * @generated from message protos.realtime.AppEventPayload.MyAccountUpdated
 */
export type AppEventPayload_MyAccountUpdated = Message<"protos.realtime.AppEventPayload.MyAccountUpdated"> & {
  /**
   * @generated from field: protos.entities.app.my_account.MyAccount my_account = 1;
   */
  myAccount?: MyAccount | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.MyAccountUpdated.
 * Use `create(AppEventPayload_MyAccountUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_MyAccountUpdatedSchema: GenMessage<AppEventPayload_MyAccountUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 1);

/**
 * @generated from message protos.realtime.AppEventPayload.AccountDeleted
 */
export type AppEventPayload_AccountDeleted = Message<"protos.realtime.AppEventPayload.AccountDeleted"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.AccountDeleted.
 * Use `create(AppEventPayload_AccountDeletedSchema)` to create a new message.
 */
export const AppEventPayload_AccountDeletedSchema: GenMessage<AppEventPayload_AccountDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 2);

/**
 * @generated from message protos.realtime.AppEventPayload.ChatCreated
 */
export type AppEventPayload_ChatCreated = Message<"protos.realtime.AppEventPayload.ChatCreated"> & {
  /**
   * @generated from field: protos.entities.app.chats.Chat chat = 1;
   */
  chat?: Chat | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.ChatCreated.
 * Use `create(AppEventPayload_ChatCreatedSchema)` to create a new message.
 */
export const AppEventPayload_ChatCreatedSchema: GenMessage<AppEventPayload_ChatCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 3);

/**
 * @generated from message protos.realtime.AppEventPayload.ChatUpdated
 */
export type AppEventPayload_ChatUpdated = Message<"protos.realtime.AppEventPayload.ChatUpdated"> & {
  /**
   * @generated from field: protos.entities.app.chats.Chat chat = 1;
   */
  chat?: Chat | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.ChatUpdated.
 * Use `create(AppEventPayload_ChatUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_ChatUpdatedSchema: GenMessage<AppEventPayload_ChatUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 4);

/**
 * @generated from message protos.realtime.AppEventPayload.ChatDeleted
 */
export type AppEventPayload_ChatDeleted = Message<"protos.realtime.AppEventPayload.ChatDeleted"> & {
  /**
   * @generated from field: string chat_id = 1;
   */
  chatId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.ChatDeleted.
 * Use `create(AppEventPayload_ChatDeletedSchema)` to create a new message.
 */
export const AppEventPayload_ChatDeletedSchema: GenMessage<AppEventPayload_ChatDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 5);

/**
 * @generated from message protos.realtime.AppEventPayload.ChatTyping
 */
export type AppEventPayload_ChatTyping = Message<"protos.realtime.AppEventPayload.ChatTyping"> & {
  /**
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.ChatTyping.
 * Use `create(AppEventPayload_ChatTypingSchema)` to create a new message.
 */
export const AppEventPayload_ChatTypingSchema: GenMessage<AppEventPayload_ChatTyping> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 6);

/**
 * @generated from message protos.realtime.AppEventPayload.MessageCreated
 */
export type AppEventPayload_MessageCreated = Message<"protos.realtime.AppEventPayload.MessageCreated"> & {
  /**
   * @generated from field: protos.entities.app.messages.Message message = 1;
   */
  message?: Message$1 | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.MessageCreated.
 * Use `create(AppEventPayload_MessageCreatedSchema)` to create a new message.
 */
export const AppEventPayload_MessageCreatedSchema: GenMessage<AppEventPayload_MessageCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 7);

/**
 * @generated from message protos.realtime.AppEventPayload.MessageUpdated
 */
export type AppEventPayload_MessageUpdated = Message<"protos.realtime.AppEventPayload.MessageUpdated"> & {
  /**
   * @generated from field: protos.entities.app.messages.Message message = 1;
   */
  message?: Message$1 | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.MessageUpdated.
 * Use `create(AppEventPayload_MessageUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_MessageUpdatedSchema: GenMessage<AppEventPayload_MessageUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 8);

/**
 * @generated from message protos.realtime.AppEventPayload.MessageDeleted
 */
export type AppEventPayload_MessageDeleted = Message<"protos.realtime.AppEventPayload.MessageDeleted"> & {
  /**
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: string client_message_id = 2;
   */
  clientMessageId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.MessageDeleted.
 * Use `create(AppEventPayload_MessageDeletedSchema)` to create a new message.
 */
export const AppEventPayload_MessageDeletedSchema: GenMessage<AppEventPayload_MessageDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 9);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectLocationCreated
 */
export type AppEventPayload_VisionProjectLocationCreated = Message<"protos.realtime.AppEventPayload.VisionProjectLocationCreated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.projects.v1.VisionLocation location = 2;
   */
  location?: VisionLocation | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectLocationCreated.
 * Use `create(AppEventPayload_VisionProjectLocationCreatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectLocationCreatedSchema: GenMessage<AppEventPayload_VisionProjectLocationCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 10);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectLocationUpdated
 */
export type AppEventPayload_VisionProjectLocationUpdated = Message<"protos.realtime.AppEventPayload.VisionProjectLocationUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.projects.v1.VisionLocation location = 2;
   */
  location?: VisionLocation | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectLocationUpdated.
 * Use `create(AppEventPayload_VisionProjectLocationUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectLocationUpdatedSchema: GenMessage<AppEventPayload_VisionProjectLocationUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 11);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectLocationDeleted
 */
export type AppEventPayload_VisionProjectLocationDeleted = Message<"protos.realtime.AppEventPayload.VisionProjectLocationDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;

  /**
   * @generated from field: repeated string image_ids = 3;
   */
  imageIds: string[];
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectLocationDeleted.
 * Use `create(AppEventPayload_VisionProjectLocationDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectLocationDeletedSchema: GenMessage<AppEventPayload_VisionProjectLocationDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 12);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectImageCreated
 */
export type AppEventPayload_VisionProjectImageCreated = Message<"protos.realtime.AppEventPayload.VisionProjectImageCreated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.assets.v1.ProjectImage image = 2;
   */
  image?: ProjectImage | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectImageCreated.
 * Use `create(AppEventPayload_VisionProjectImageCreatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectImageCreatedSchema: GenMessage<AppEventPayload_VisionProjectImageCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 13);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionInviteCreated
 */
export type AppEventPayload_VisionInviteCreated = Message<"protos.realtime.AppEventPayload.VisionInviteCreated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.membership.v1.VisionInviteView invite = 2;
   */
  invite?: VisionInviteView | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionInviteCreated.
 * Use `create(AppEventPayload_VisionInviteCreatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionInviteCreatedSchema: GenMessage<AppEventPayload_VisionInviteCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 14);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionInviteDeleted
 */
export type AppEventPayload_VisionInviteDeleted = Message<"protos.realtime.AppEventPayload.VisionInviteDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string invite_id = 2;
   */
  inviteId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionInviteDeleted.
 * Use `create(AppEventPayload_VisionInviteDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionInviteDeletedSchema: GenMessage<AppEventPayload_VisionInviteDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 15);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionMemberJoined
 */
export type AppEventPayload_VisionMemberJoined = Message<"protos.realtime.AppEventPayload.VisionMemberJoined"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.membership.v1.VisionMemberView member = 2;
   */
  member?: VisionMemberView | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionMemberJoined.
 * Use `create(AppEventPayload_VisionMemberJoinedSchema)` to create a new message.
 */
export const AppEventPayload_VisionMemberJoinedSchema: GenMessage<AppEventPayload_VisionMemberJoined> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 16);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionMemberRemoved
 */
export type AppEventPayload_VisionMemberRemoved = Message<"protos.realtime.AppEventPayload.VisionMemberRemoved"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionMemberRemoved.
 * Use `create(AppEventPayload_VisionMemberRemovedSchema)` to create a new message.
 */
export const AppEventPayload_VisionMemberRemovedSchema: GenMessage<AppEventPayload_VisionMemberRemoved> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 17);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionMemberRoleChanged
 */
export type AppEventPayload_VisionMemberRoleChanged = Message<"protos.realtime.AppEventPayload.VisionMemberRoleChanged"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.membership.v1.VisionMemberView member = 2;
   */
  member?: VisionMemberView | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionMemberRoleChanged.
 * Use `create(AppEventPayload_VisionMemberRoleChangedSchema)` to create a new message.
 */
export const AppEventPayload_VisionMemberRoleChangedSchema: GenMessage<AppEventPayload_VisionMemberRoleChanged> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 18);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectOwnershipTransferred
 */
export type AppEventPayload_VisionProjectOwnershipTransferred = Message<"protos.realtime.AppEventPayload.VisionProjectOwnershipTransferred"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string old_owner_account_id = 2;
   */
  oldOwnerAccountId: string;

  /**
   * @generated from field: string new_owner_account_id = 3;
   */
  newOwnerAccountId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectOwnershipTransferred.
 * Use `create(AppEventPayload_VisionProjectOwnershipTransferredSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectOwnershipTransferredSchema: GenMessage<AppEventPayload_VisionProjectOwnershipTransferred> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 19);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectImageCategorized
 */
export type AppEventPayload_VisionProjectImageCategorized = Message<"protos.realtime.AppEventPayload.VisionProjectImageCategorized"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string asset_id = 2;
   */
  assetId: string;

  /**
   * @generated from field: string location_id = 3;
   */
  locationId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectImageCategorized.
 * Use `create(AppEventPayload_VisionProjectImageCategorizedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectImageCategorizedSchema: GenMessage<AppEventPayload_VisionProjectImageCategorized> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 20);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectImagesCategorized
 */
export type AppEventPayload_VisionProjectImagesCategorized = Message<"protos.realtime.AppEventPayload.VisionProjectImagesCategorized"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated protos.realtime.AppEventPayload.VisionProjectImagesCategorized.Assignment assignments = 2;
   */
  assignments: AppEventPayload_VisionProjectImagesCategorized_Assignment[];
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectImagesCategorized.
 * Use `create(AppEventPayload_VisionProjectImagesCategorizedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectImagesCategorizedSchema: GenMessage<AppEventPayload_VisionProjectImagesCategorized> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 21);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectImagesCategorized.Assignment
 */
export type AppEventPayload_VisionProjectImagesCategorized_Assignment = Message<"protos.realtime.AppEventPayload.VisionProjectImagesCategorized.Assignment"> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectImagesCategorized.Assignment.
 * Use `create(AppEventPayload_VisionProjectImagesCategorized_AssignmentSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectImagesCategorized_AssignmentSchema: GenMessage<AppEventPayload_VisionProjectImagesCategorized_Assignment> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 21, 0);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionGenerationStarted
 */
export type AppEventPayload_VisionGenerationStarted = Message<"protos.realtime.AppEventPayload.VisionGenerationStarted"> & {
  /**
   * @generated from field: protos.vision.generations.v1.VisionGeneration generation = 1;
   */
  generation?: VisionGeneration | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionGenerationStarted.
 * Use `create(AppEventPayload_VisionGenerationStartedSchema)` to create a new message.
 */
export const AppEventPayload_VisionGenerationStartedSchema: GenMessage<AppEventPayload_VisionGenerationStarted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 22);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionGenerationCompleted
 */
export type AppEventPayload_VisionGenerationCompleted = Message<"protos.realtime.AppEventPayload.VisionGenerationCompleted"> & {
  /**
   * @generated from field: protos.vision.generations.v1.VisionGeneration generation = 1;
   */
  generation?: VisionGeneration | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionGenerationCompleted.
 * Use `create(AppEventPayload_VisionGenerationCompletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionGenerationCompletedSchema: GenMessage<AppEventPayload_VisionGenerationCompleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 23);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionGenerationUpdated
 */
export type AppEventPayload_VisionGenerationUpdated = Message<"protos.realtime.AppEventPayload.VisionGenerationUpdated"> & {
  /**
   * @generated from field: protos.vision.generations.v1.VisionGeneration generation = 1;
   */
  generation?: VisionGeneration | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionGenerationUpdated.
 * Use `create(AppEventPayload_VisionGenerationUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionGenerationUpdatedSchema: GenMessage<AppEventPayload_VisionGenerationUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 24);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionGenerationLikesUpdated
 */
export type AppEventPayload_VisionGenerationLikesUpdated = Message<"protos.realtime.AppEventPayload.VisionGenerationLikesUpdated"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string project_id = 3;
   */
  projectId: string;

  /**
   * @generated from field: repeated protos.vision.generations.v1.VisionGenerationLike likes = 4;
   */
  likes: VisionGenerationLike[];
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionGenerationLikesUpdated.
 * Use `create(AppEventPayload_VisionGenerationLikesUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionGenerationLikesUpdatedSchema: GenMessage<AppEventPayload_VisionGenerationLikesUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 25);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionGenerationFailed
 */
export type AppEventPayload_VisionGenerationFailed = Message<"protos.realtime.AppEventPayload.VisionGenerationFailed"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string project_id = 3;
   */
  projectId: string;

  /**
   * @generated from field: string error_message = 4;
   */
  errorMessage: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionGenerationFailed.
 * Use `create(AppEventPayload_VisionGenerationFailedSchema)` to create a new message.
 */
export const AppEventPayload_VisionGenerationFailedSchema: GenMessage<AppEventPayload_VisionGenerationFailed> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 26);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectCreditsUpdated
 */
export type AppEventPayload_VisionProjectCreditsUpdated = Message<"protos.realtime.AppEventPayload.VisionProjectCreditsUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: int64 project_credits = 2;
   */
  projectCredits: bigint;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectCreditsUpdated.
 * Use `create(AppEventPayload_VisionProjectCreditsUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectCreditsUpdatedSchema: GenMessage<AppEventPayload_VisionProjectCreditsUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 27);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionChatMessageCreated
 */
export type AppEventPayload_VisionChatMessageCreated = Message<"protos.realtime.AppEventPayload.VisionChatMessageCreated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.chat.v1.VisionChatMessage message = 2;
   */
  message?: VisionChatMessage | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionChatMessageCreated.
 * Use `create(AppEventPayload_VisionChatMessageCreatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionChatMessageCreatedSchema: GenMessage<AppEventPayload_VisionChatMessageCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 28);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionChatMessageDeleted
 */
export type AppEventPayload_VisionChatMessageDeleted = Message<"protos.realtime.AppEventPayload.VisionChatMessageDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string message_id = 3;
   */
  messageId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionChatMessageDeleted.
 * Use `create(AppEventPayload_VisionChatMessageDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionChatMessageDeletedSchema: GenMessage<AppEventPayload_VisionChatMessageDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 29);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionDisplaySelectionChanged
 */
export type AppEventPayload_VisionDisplaySelectionChanged = Message<"protos.realtime.AppEventPayload.VisionDisplaySelectionChanged"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string generation_id = 3;
   */
  generationId: string;

  /**
   * @generated from field: string generated_thumbnail_url = 4;
   */
  generatedThumbnailUrl: string;

  /**
   * @generated from field: string graded_thumbnail_url = 5;
   */
  gradedThumbnailUrl: string;

  /**
   * @generated from field: bool display_user_locked = 6;
   */
  displayUserLocked: boolean;

  /**
   * @generated from field: protos.vision.generations.v1.GenerationCrop crop = 7;
   */
  crop?: GenerationCrop | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionDisplaySelectionChanged.
 * Use `create(AppEventPayload_VisionDisplaySelectionChangedSchema)` to create a new message.
 */
export const AppEventPayload_VisionDisplaySelectionChangedSchema: GenMessage<AppEventPayload_VisionDisplaySelectionChanged> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 30);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionImagesReordered
 */
export type AppEventPayload_VisionImagesReordered = Message<"protos.realtime.AppEventPayload.VisionImagesReordered"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;

  /**
   * @generated from field: repeated string image_ids = 3;
   */
  imageIds: string[];
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionImagesReordered.
 * Use `create(AppEventPayload_VisionImagesReorderedSchema)` to create a new message.
 */
export const AppEventPayload_VisionImagesReorderedSchema: GenMessage<AppEventPayload_VisionImagesReordered> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 31);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionGenerationDeleted
 */
export type AppEventPayload_VisionGenerationDeleted = Message<"protos.realtime.AppEventPayload.VisionGenerationDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string generation_id = 3;
   */
  generationId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionGenerationDeleted.
 * Use `create(AppEventPayload_VisionGenerationDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionGenerationDeletedSchema: GenMessage<AppEventPayload_VisionGenerationDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 32);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionImageRotated
 */
export type AppEventPayload_VisionImageRotated = Message<"protos.realtime.AppEventPayload.VisionImageRotated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.assets.v1.ProjectImage image = 2;
   */
  image?: ProjectImage | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionImageRotated.
 * Use `create(AppEventPayload_VisionImageRotatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionImageRotatedSchema: GenMessage<AppEventPayload_VisionImageRotated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 33);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionGenerationCropUpdated
 */
export type AppEventPayload_VisionGenerationCropUpdated = Message<"protos.realtime.AppEventPayload.VisionGenerationCropUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string generation_id = 3;
   */
  generationId: string;

  /**
   * @generated from field: protos.vision.generations.v1.GenerationCrop crop = 4;
   */
  crop?: GenerationCrop | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionGenerationCropUpdated.
 * Use `create(AppEventPayload_VisionGenerationCropUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionGenerationCropUpdatedSchema: GenMessage<AppEventPayload_VisionGenerationCropUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 34);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionImageMaskRegionsUpdated
 */
export type AppEventPayload_VisionImageMaskRegionsUpdated = Message<"protos.realtime.AppEventPayload.VisionImageMaskRegionsUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string updated_by_account_id = 3;
   */
  updatedByAccountId: string;

  /**
   * @generated from field: repeated protos.vision.generations.v1.MaskRegion regions = 4;
   */
  regions: MaskRegion[];
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionImageMaskRegionsUpdated.
 * Use `create(AppEventPayload_VisionImageMaskRegionsUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionImageMaskRegionsUpdatedSchema: GenMessage<AppEventPayload_VisionImageMaskRegionsUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 35);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionGenerationMaskRegionsUpdated
 */
export type AppEventPayload_VisionGenerationMaskRegionsUpdated = Message<"protos.realtime.AppEventPayload.VisionGenerationMaskRegionsUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * @generated from field: string updated_by_account_id = 3;
   */
  updatedByAccountId: string;

  /**
   * @generated from field: repeated protos.vision.generations.v1.MaskRegion regions = 4;
   */
  regions: MaskRegion[];
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionGenerationMaskRegionsUpdated.
 * Use `create(AppEventPayload_VisionGenerationMaskRegionsUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionGenerationMaskRegionsUpdatedSchema: GenMessage<AppEventPayload_VisionGenerationMaskRegionsUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 36);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistShotsCreated
 */
export type AppEventPayload_VisionShotlistShotsCreated = Message<"protos.realtime.AppEventPayload.VisionShotlistShotsCreated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShot shots = 2;
   */
  shots: VisionShot[];
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistShotsCreated.
 * Use `create(AppEventPayload_VisionShotlistShotsCreatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistShotsCreatedSchema: GenMessage<AppEventPayload_VisionShotlistShotsCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 37);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistShotUpdated
 */
export type AppEventPayload_VisionShotlistShotUpdated = Message<"protos.realtime.AppEventPayload.VisionShotlistShotUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShot shot = 2;
   */
  shot?: VisionShot | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistShotUpdated.
 * Use `create(AppEventPayload_VisionShotlistShotUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistShotUpdatedSchema: GenMessage<AppEventPayload_VisionShotlistShotUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 38);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistShotDeleted
 */
export type AppEventPayload_VisionShotlistShotDeleted = Message<"protos.realtime.AppEventPayload.VisionShotlistShotDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string shot_id = 2;
   */
  shotId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistShotDeleted.
 * Use `create(AppEventPayload_VisionShotlistShotDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistShotDeletedSchema: GenMessage<AppEventPayload_VisionShotlistShotDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 39);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistShotHidden
 */
export type AppEventPayload_VisionShotlistShotHidden = Message<"protos.realtime.AppEventPayload.VisionShotlistShotHidden"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string shot_id = 2;
   */
  shotId: string;

  /**
   * @generated from field: string image_id = 3;
   */
  imageId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistShotHidden.
 * Use `create(AppEventPayload_VisionShotlistShotHiddenSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistShotHiddenSchema: GenMessage<AppEventPayload_VisionShotlistShotHidden> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 40);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistCastCreated
 */
export type AppEventPayload_VisionShotlistCastCreated = Message<"protos.realtime.AppEventPayload.VisionShotlistCastCreated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionCastMember cast = 2;
   */
  cast?: VisionCastMember | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistCastCreated.
 * Use `create(AppEventPayload_VisionShotlistCastCreatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistCastCreatedSchema: GenMessage<AppEventPayload_VisionShotlistCastCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 41);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistCastUpdated
 */
export type AppEventPayload_VisionShotlistCastUpdated = Message<"protos.realtime.AppEventPayload.VisionShotlistCastUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionCastMember cast = 2;
   */
  cast?: VisionCastMember | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistCastUpdated.
 * Use `create(AppEventPayload_VisionShotlistCastUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistCastUpdatedSchema: GenMessage<AppEventPayload_VisionShotlistCastUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 42);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistCastDeleted
 */
export type AppEventPayload_VisionShotlistCastDeleted = Message<"protos.realtime.AppEventPayload.VisionShotlistCastDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string cast_id = 2;
   */
  castId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistCastDeleted.
 * Use `create(AppEventPayload_VisionShotlistCastDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistCastDeletedSchema: GenMessage<AppEventPayload_VisionShotlistCastDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 43);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistPropCreated
 */
export type AppEventPayload_VisionShotlistPropCreated = Message<"protos.realtime.AppEventPayload.VisionShotlistPropCreated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionProp prop = 2;
   */
  prop?: VisionProp | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistPropCreated.
 * Use `create(AppEventPayload_VisionShotlistPropCreatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistPropCreatedSchema: GenMessage<AppEventPayload_VisionShotlistPropCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 44);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistPropDeleted
 */
export type AppEventPayload_VisionShotlistPropDeleted = Message<"protos.realtime.AppEventPayload.VisionShotlistPropDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string prop_id = 2;
   */
  propId: string;

  /**
   * @generated from field: string prop_name = 3;
   */
  propName: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistPropDeleted.
 * Use `create(AppEventPayload_VisionShotlistPropDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistPropDeletedSchema: GenMessage<AppEventPayload_VisionShotlistPropDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 45);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistPresetCreated
 */
export type AppEventPayload_VisionShotlistPresetCreated = Message<"protos.realtime.AppEventPayload.VisionShotlistPresetCreated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShotlistPresetCategory category = 2;
   */
  category: VisionShotlistPresetCategory;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShotlistPreset preset = 3;
   */
  preset?: VisionShotlistPreset | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistPresetCreated.
 * Use `create(AppEventPayload_VisionShotlistPresetCreatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistPresetCreatedSchema: GenMessage<AppEventPayload_VisionShotlistPresetCreated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 46);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionShotlistConfigUpdated
 */
export type AppEventPayload_VisionShotlistConfigUpdated = Message<"protos.realtime.AppEventPayload.VisionShotlistConfigUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShotlistConfig config = 2;
   */
  config?: VisionShotlistConfig | undefined;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionShotlistConfigUpdated.
 * Use `create(AppEventPayload_VisionShotlistConfigUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionShotlistConfigUpdatedSchema: GenMessage<AppEventPayload_VisionShotlistConfigUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 47);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionImageDescriptionUpdated
 */
export type AppEventPayload_VisionImageDescriptionUpdated = Message<"protos.realtime.AppEventPayload.VisionImageDescriptionUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionImageDescriptionUpdated.
 * Use `create(AppEventPayload_VisionImageDescriptionUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionImageDescriptionUpdatedSchema: GenMessage<AppEventPayload_VisionImageDescriptionUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 48);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionImageFrameUpdated
 */
export type AppEventPayload_VisionImageFrameUpdated = Message<"protos.realtime.AppEventPayload.VisionImageFrameUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string frame_number = 3;
   */
  frameNumber: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionImageFrameUpdated.
 * Use `create(AppEventPayload_VisionImageFrameUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionImageFrameUpdatedSchema: GenMessage<AppEventPayload_VisionImageFrameUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 49);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectImageMoved
 */
export type AppEventPayload_VisionProjectImageMoved = Message<"protos.realtime.AppEventPayload.VisionProjectImageMoved"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string to_location_id = 3;
   */
  toLocationId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectImageMoved.
 * Use `create(AppEventPayload_VisionProjectImageMovedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectImageMovedSchema: GenMessage<AppEventPayload_VisionProjectImageMoved> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 50);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectImagesBulkMoved
 */
export type AppEventPayload_VisionProjectImagesBulkMoved = Message<"protos.realtime.AppEventPayload.VisionProjectImagesBulkMoved"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated string image_ids = 2;
   */
  imageIds: string[];

  /**
   * @generated from field: string to_location_id = 3;
   */
  toLocationId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectImagesBulkMoved.
 * Use `create(AppEventPayload_VisionProjectImagesBulkMovedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectImagesBulkMovedSchema: GenMessage<AppEventPayload_VisionProjectImagesBulkMoved> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 51);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectImageDeleted
 */
export type AppEventPayload_VisionProjectImageDeleted = Message<"protos.realtime.AppEventPayload.VisionProjectImageDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectImageDeleted.
 * Use `create(AppEventPayload_VisionProjectImageDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectImageDeletedSchema: GenMessage<AppEventPayload_VisionProjectImageDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 52);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectUncategorizedImagesDeleted
 */
export type AppEventPayload_VisionProjectUncategorizedImagesDeleted = Message<"protos.realtime.AppEventPayload.VisionProjectUncategorizedImagesDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated string image_ids = 2;
   */
  imageIds: string[];
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectUncategorizedImagesDeleted.
 * Use `create(AppEventPayload_VisionProjectUncategorizedImagesDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectUncategorizedImagesDeletedSchema: GenMessage<AppEventPayload_VisionProjectUncategorizedImagesDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 53);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectSettingsUpdated
 */
export type AppEventPayload_VisionProjectSettingsUpdated = Message<"protos.realtime.AppEventPayload.VisionProjectSettingsUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectSettingsUpdated.
 * Use `create(AppEventPayload_VisionProjectSettingsUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectSettingsUpdatedSchema: GenMessage<AppEventPayload_VisionProjectSettingsUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 54);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionProjectDeleted
 */
export type AppEventPayload_VisionProjectDeleted = Message<"protos.realtime.AppEventPayload.VisionProjectDeleted"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionProjectDeleted.
 * Use `create(AppEventPayload_VisionProjectDeletedSchema)` to create a new message.
 */
export const AppEventPayload_VisionProjectDeletedSchema: GenMessage<AppEventPayload_VisionProjectDeleted> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 55);

/**
 * @generated from message protos.realtime.AppEventPayload.VisionPresenceUpdated
 */
export type AppEventPayload_VisionPresenceUpdated = Message<"protos.realtime.AppEventPayload.VisionPresenceUpdated"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string pfp_url = 4;
   */
  pfpUrl: string;

  /**
   * @generated from field: protos.vision.projects.v1.VisionPresenceKind kind = 5;
   */
  kind: VisionPresenceKind;

  /**
   * @generated from field: string image_id = 6;
   */
  imageId: string;

  /**
   * @generated from field: string generation_id = 7;
   */
  generationId: string;

  /**
   * @generated from field: string grading_lock_generation_id = 8;
   */
  gradingLockGenerationId: string;

  /**
   * @generated from field: string crop_lock_generation_id = 9;
   */
  cropLockGenerationId: string;
};

/**
 * Describes the message protos.realtime.AppEventPayload.VisionPresenceUpdated.
 * Use `create(AppEventPayload_VisionPresenceUpdatedSchema)` to create a new message.
 */
export const AppEventPayload_VisionPresenceUpdatedSchema: GenMessage<AppEventPayload_VisionPresenceUpdated> = /*@__PURE__*/
  messageDesc(file_realtime_app_event_payload, 0, 56);

